<template>
  <div class="header">
    <div class="logo">
      <img src="@/assets/img/logo.jpg" />
    </div>
    <div class="nav">
      <!-- <head-bar /> -->
      <br>
      <div class="store">
        <!-- <span class="name">{{ user.nickname }}</span> -->
        <el-dropdown trigger="click" class="dropdown">
          <el-button type="primary" class="el-dropdown-link">
            <span>{{ user.nickname }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in ownStores" :key="item.id" @click.native="switch_store(item.id)">
              <span :class="{ active: store.id === item.id }">{{ item.storename }}</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="logout">
              <span>--退出登录--</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import HeadBar from '../menu/headbar'

export default {
  name: 'v-header',
  // components: { HeadBar },
  computed: {
    ...mapGetters(['store', 'ownStores', 'user'])
  },
  methods: {
    async switch_store(id) {
      try {
        const { data } = await this.$api.post_switch_store(id, { store_id: id })
        await this.$store.dispatch('init', data)
        location.reload()
      } catch (e) {
        console.log(e)
      }
    },
    logout() {
      this.$router.push('/logout')
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  width: 200px;
  height: 100%;
  flex-shrink: 0;
  font-size: 46px;
  text-align: center;
  color: #fff;
  background-color: #00284d;
}

.nav {
  width: 0;
  flex: 1;
  padding: 0 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .store {
    color: #fff;
    display: flex;
    align-items: center;

    .name {
      margin-right: 20px;
    }
  }
}
</style>
